import { defineMessages } from 'react-intl';

const commonModulesTranslations = defineMessages({
    ng_common_alerts: {
        id: 'ng_alerts_alerts',
        defaultMessage: 'Alerts'
    },
    ng_common_groups: {
        id: 'Grp2',
        defaultMessage: 'Groups'
    },
    ng_common_contacts: {
        id: 'ng_common_contacts',
        defaultMessage: 'Contacts'
    },
    ng_common_people: {
        id: 'ng_common_people',
        defaultMessage: 'People'
    }
});

export default commonModulesTranslations;
